import { Controller } from "@hotwired/stimulus"

// A compact destination menu with drill-in panels in the same popover. Keeping
// one panel avoids hover-only flyouts and keeps the complete menu on a phone.
export default class extends Controller {
    static targets = ["pane"]

    get split() { return this.application.getControllerForElementAndIdentifier(this.element, "split-menu") }
    get visiblePane() { return this.paneTargets.find(pane => !pane.hidden) }

    reset() { this.display("main") }

    display(name) {
        this.paneTargets.forEach(pane => { pane.hidden = pane.dataset.pane !== name })
        this.element.querySelectorAll('[aria-haspopup="menu"][data-pane]').forEach(button => {
            button.setAttribute("aria-expanded", String(button.dataset.pane === name))
        })
        if (this.split?.menuTarget.classList.contains("is-open")) this.split.reposition()
    }

    show(event) {
        this.parent = event.currentTarget
        this.display(event.currentTarget.dataset.pane)
        this.visiblePane?.querySelector("button")?.focus()
    }

    back() {
        this.display("main")
        this.parent?.focus()
    }

    keydown(event) {
        if (!this.split?.menuTarget.classList.contains("is-open")) return
        if (event.key === "Escape") {
            event.preventDefault()
            event.stopImmediatePropagation()
            if (this.visiblePane?.dataset.pane !== "main") this.back()
            else { this.split.close(); this.split.caretTarget.focus() }
        } else if (event.key === "ArrowLeft" && this.visiblePane?.dataset.pane !== "main") {
            event.preventDefault()
            this.back()
        } else if (event.key === "ArrowRight" && event.target.matches('[data-action="composer-menu#show"]')) {
            event.preventDefault()
            event.target.click()
        } else if (["ArrowDown", "ArrowUp", "Home", "End"].includes(event.key)) {
            event.preventDefault()
            const rows = Array.from(this.visiblePane.querySelectorAll("button:not(:disabled), a[href]"))
            const index = rows.indexOf(document.activeElement)
            const next = event.key === "Home" ? 0 : event.key === "End" ? rows.length - 1 :
                (index + (event.key === "ArrowDown" ? 1 : -1) + rows.length) % rows.length
            rows[next]?.focus()
        }
    }
}
